import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import { Collection } from 'core/model/Collection';
import { observable } from 'mobx';
import { Model } from 'core/model/Model';
export let DeviceSyslogsCollection = (_dec = observable.ref, _class = class DeviceSyslogsCollection extends Collection {
  get model() {
    return Model;
  }
  constructor(device) {
    super();
    _initializerDefineProperty(this, "device", _descriptor, this);
    this.device = device;
    this.requestStatus = 'awaitingRequest';
  }
  get url() {
    return `/api/ui/devices/${this.device.id}/syslog/query`;
  }
  get fetchMethod() {
    return 'post';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "device", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);